import gaHttpStatus from './google_analytics/http_status';
import karteClient from '../common/karte/error';

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector<HTMLElement>('#error_detection');
  const staffId = el?.dataset.staffId;
  const currentPath = el?.dataset.currentPath;
  const now = el?.dataset.now;

  if(staffId && currentPath && now) {
    const message = document.querySelector('.alert.alert-danger')?.textContent;
    const page500 = document.querySelector('#internal_server_error');

    if(message) {
      // エラーイベントを送信 (GA)
      gaHttpStatus.return4xx({
        time: now,
        path: currentPath,
        staffId,
        message,
      })

      // エラーイベントを送信 (KARTE)
      karteClient.return4xx({
        path: currentPath,
        message: message
      });
    } else if(page500) {
      // エラーイベントを送信 (GA)
      gaHttpStatus.return5xx({
        time: now,
        path: currentPath,
        staffId
      })

      // エラーイベントを送信 (KARTE)
      karteClient.return5xx({
        path: currentPath,
        message: ''
      });
    }
  }
});
